export const environment = {
    production: true,
    //appUrl: 'http://localhost:8050/api/v1/',               // local 
    appUrl: 'https://api.asasdrive.com/api/v1/', // dev 
    //appUrl: 'https://api.asasdrive.com/api/v1/',           // live
    
    cmsAttachmentUrl: 'https://api.asasdrive.com/',
    //cmsAttachmentUrl:'aaaaadev.api.sharewinds.com/',
    environmentName: 'dev',

    //reportUrl: 'https://asasconnect.com/',
    reportUrl: 'https://tab.asasdrive.com/',
    timeoutMinutes: 60
};
